import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AppBankService } from 'app/business/service/app/app-bank.service';
import { AppMasterService } from 'app/business/service/app/app-master.service';
import { ConfirmPopupComponent } from '../../confirm-popup/confirm-popup.component';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service'

@Component({
  selector: 'app-mark-type-header-popup',
  templateUrl: './mark-type-header-popup.component.html',
  styleUrls: ['./mark-type-header-popup.component.css']
})
export class MarkTypeHeaderPopupComponent implements OnInit {
  form: any = {};
  bankList: any;
  attachType: any[] = [];
  fieldType: any[] = [];
  buttonList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) data,
    public dialogRef: MatDialogRef<MarkTypeHeaderPopupComponent>,
    private appMasterService: AppMasterService,
    private dialog: MatDialog,
    private alertMessageService: AlertMessageService
  ) {
    this.buttonList = data.buttonList;
    if (data.e) {
      this.form = data.e;
    } else {
      this.form.isActive = 'Y';
      this.form.attachTypeId = 0;
      this.form.fieldTypeId = 0;
    }
    
  }

  ngOnInit(): void {
    this.appMasterService.getListAttachType({}).then(res => {
      if (res === "error") {
        return;
      } else {
        this.attachType = res;
      }
    });

    this.appMasterService.getMasterFieldType({}).then(res => {
      if (res === "error") {
        return;
      } else {
        this.fieldType = res;
      }
    })
  }

  save() {
    
    if (this.form.attachTypeId !== 0 && this.form.fieldTypeId !== 0) {
      const data = {
        "marktypeHId": this.form.marktypeHId,
        "attachTypeId": this.form.attachTypeId,
        "fieldTypeId": this.form.fieldTypeId,
        "fieldTypeName": this.fieldType.find(e => e.fieldTypeId === this.form.fieldTypeId).fieldTypeName,
        "isActive": this.form.isActive
      };

      this.appMasterService.saveMarktypeHeader(data).then((res: any) => {
        if (res === "error") {
          this.alertMessageService.open({message: "บันทึกข้อมูลไม่สำเร็จ", title:""});
        } else {
          this.dialogRef.close();
          this.alertMessageService.open({message: "บันทึกข้อมูลสำเร็จ", title:""});
        }
      });

    } else {
      this.alertMessageService.open({ message: "กรุณากรอกข้อมูลให้ครบ", title: "ข้อผิดพลาด" });
    }
  }

  onChange(e) {
    if (e.checked == true) {
      this.form.isActive = "Y";
    } else {
      this.form.isActive = "N";
    }
  }

  endPopup(e) {
    const dialogRef = this.dialog.open(ConfirmPopupComponent, {
      disableClose: false,
      // width: '30vw',
      data: {
        header: e,
        button: 'close'
      },
      maxWidth: 'none'
    });

    dialogRef.afterClosed().subscribe(res => {
      this.dialogRef.close();
    });
  }
}
